import {assign, Machine} from 'xstate';

const hours = 48;

const ManualPalletMachine = Machine({

        id: "manualPallet",
        context: {
            palletData: {},
            hours: hours
        },
        initial: "init",
        ERROR: {
            target: "error",
            actions: ["logError"]
        },
        states: {
            init: {
                on: {
                    NEXT: {
                        target: "loadChooseJobsData",
                        actions: assign({ palletData: (context, event) => event })
                    }
                },
                entry: ['logError'],
            },
            error: {
                on: {
                    STARTOVER: {
                        target: "init"
                    }
                },
                entry: ['logError'],
            },
            loadChooseJobsData: {
                invoke: {
                    src: 'loadPalletEventData',
                    onDone: {
                        target: 'chooseJobs',
                        actions: assign({ chooseJobs: (context, event) => event.data })
                    },
                    onError: {
                        target: 'error',
                        actions: assign({ error: (context, event) => {return {errorEventData: event.data}}})
                    }
                }
            },
            chooseJobs: {
                on: {
                    NEXT: {
                        target: "savingPallet",
                        actions: assign({ selectedJobs: (context, event) => event.selectedJobs })
                    },
                    BACK: {
                        target: "init"
                    },
                }
            },
            savingPallet: {
                invoke: {
                    src: 'savePallet',
                    onDone: {
                        target: 'selectPrintOptions',
                    },
                    onError: {
                        target: 'error',
                        actions: assign({ error: (context, event) => {return {errorEventData: event.data}}})
                    }
                }
            },
            selectPrintOptions: {
                on: {
                    CONFIRM: {
                        target: "generatingDatasource",
                        actions: assign({ printOptions: (context, event) => event })
                    },
                    BACK: {
                        target: "chooseJobs",
                    }
                }
            },
            generatingDatasource: {
                invoke: {
                    src: 'generateDataSource',
                    onDone: {
                        target: 'printingManifest',
                        actions: assign({ pallet: (context, event) => event.data })
                    },
                    onError: {
                        target: 'error',
                        actions: assign({ error: (context, event) => {return {errorEventData: event.data}}})
                    }
                }
            },
            printingManifest: {
                invoke: {
                    src: 'printManifest',
                    onDone: {
                        target: 'finished',
                    },
                    onError: {
                        target: 'error',
                        actions: assign({ error: (context, event) => {return {errorEventData: event.data}}})
                    }
                }
            },

            finished: {
                after: {
                    3000: 'init'
                }

            },

        },
    },
);

export default ManualPalletMachine;